import React from 'react';
import Navbar from '../components/Navbar';

const PrivacyPolicy = () => {
  return (
    <div className="min-h-screen bg-gray-50">
      <Navbar />
      
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-24">
        <div className="bg-white rounded-lg shadow-lg p-8">
          <h1 className="text-4xl font-bold text-gray-900 mb-8">Privacy Policy</h1>
          
          <div className="prose prose-lg max-w-none">
            <p className="text-gray-600 mb-6">
              <strong>Effective Date:</strong> January 1, 2025<br />
              <strong>Last Updated:</strong> January 1, 2025
            </p>

            <h2 className="text-2xl font-semibold text-gray-800 mb-4">1. Information We Collect</h2>
            
            <h3 className="text-xl font-semibold text-gray-800 mb-3">Personal Information</h3>
            <ul className="text-gray-600 mb-4 space-y-2">
              <li>• Name, email address, and contact information</li>
              <li>• Business information and marketing preferences</li>
              <li>• Payment and billing information</li>
              <li>• Communication records and support interactions</li>
            </ul>

            <h3 className="text-xl font-semibold text-gray-800 mb-3">Automatically Collected Information</h3>
            <ul className="text-gray-600 mb-6 space-y-2">
              <li>• IP address, browser type, and device information</li>
              <li>• Website usage data and analytics</li>
              <li>• Cookies and similar tracking technologies</li>
              <li>• Location data (with your consent)</li>
            </ul>

            <h2 className="text-2xl font-semibold text-gray-800 mb-4">2. How We Use Your Information</h2>
            <ul className="text-gray-600 mb-6 space-y-2">
              <li>• Provide and improve our digital marketing services</li>
              <li>• Process payments and manage your account</li>
              <li>• Communicate with you about our services</li>
              <li>• Send marketing materials (with your consent)</li>
              <li>• Analyze website usage and optimize user experience</li>
              <li>• Comply with legal obligations and protect our rights</li>
            </ul>

            <h2 className="text-2xl font-semibold text-gray-800 mb-4">3. Information Sharing</h2>
            <p className="text-gray-600 mb-4">
              We do not sell your personal information. We may share your information in the 
              following circumstances:
            </p>
            <ul className="text-gray-600 mb-6 space-y-2">
              <li>• With service providers who assist in our operations</li>
              <li>• When required by law or legal process</li>
              <li>• To protect our rights or the safety of others</li>
              <li>• In connection with a business transaction (merger, acquisition)</li>
              <li>• With your explicit consent</li>
            </ul>

            <h2 className="text-2xl font-semibold text-gray-800 mb-4">4. Data Security</h2>
            <p className="text-gray-600 mb-4">
              We implement appropriate technical and organizational measures to protect your 
              personal information:
            </p>
            <ul className="text-gray-600 mb-6 space-y-2">
              <li>• Encryption of data in transit and at rest</li>
              <li>• Regular security assessments and updates</li>
              <li>• Access controls and employee training</li>
              <li>• Secure hosting and backup systems</li>
            </ul>

            <h2 className="text-2xl font-semibold text-gray-800 mb-4">5. Your Rights and Choices</h2>
            <p className="text-gray-600 mb-4">
              Depending on your location, you may have the following rights:
            </p>
            <ul className="text-gray-600 mb-6 space-y-2">
              <li>• Access and receive a copy of your personal information</li>
              <li>• Correct inaccurate or incomplete information</li>
              <li>• Delete your personal information</li>
              <li>• Restrict or object to processing</li>
              <li>• Data portability</li>
              <li>• Withdraw consent at any time</li>
            </ul>

            <h2 className="text-2xl font-semibold text-gray-800 mb-4">6. Cookies and Tracking</h2>
            <p className="text-gray-600 mb-4">
              We use cookies and similar technologies to:
            </p>
            <ul className="text-gray-600 mb-6 space-y-2">
              <li>• Remember your preferences and settings</li>
              <li>• Analyze website traffic and user behavior</li>
              <li>• Provide personalized content and advertising</li>
              <li>• Improve our services and user experience</li>
            </ul>
            <p className="text-gray-600 mb-6">
              You can control cookies through your browser settings, but some features may not 
              function properly if cookies are disabled.
            </p>

            <h2 className="text-2xl font-semibold text-gray-800 mb-4">7. Third-Party Services</h2>
            <p className="text-gray-600 mb-6">
              Our services may integrate with third-party platforms and tools. These third parties 
              have their own privacy policies, and we encourage you to review them. We are not 
              responsible for the privacy practices of third-party services.
            </p>

            <h2 className="text-2xl font-semibold text-gray-800 mb-4">8. Data Retention</h2>
            <p className="text-gray-600 mb-6">
              We retain your personal information for as long as necessary to provide our services 
              and comply with legal obligations. When we no longer need your information, we will 
              securely delete or anonymize it.
            </p>

            <h2 className="text-2xl font-semibold text-gray-800 mb-4">9. Children's Privacy</h2>
            <p className="text-gray-600 mb-6">
              Our services are not intended for children under 13 years of age. We do not knowingly 
              collect personal information from children under 13. If we learn that we have collected 
              such information, we will delete it immediately.
            </p>

            <h2 className="text-2xl font-semibold text-gray-800 mb-4">10. International Transfers</h2>
            <p className="text-gray-600 mb-6">
              Your information may be transferred to and processed in countries other than your own. 
              We ensure appropriate safeguards are in place to protect your information during such 
              transfers.
            </p>

            <h2 className="text-2xl font-semibold text-gray-800 mb-4">11. Changes to This Policy</h2>
            <p className="text-gray-600 mb-6">
              We may update this privacy policy from time to time. We will notify you of any 
              material changes by posting the new policy on our website and updating the effective 
              date.
            </p>

            <h2 className="text-2xl font-semibold text-gray-800 mb-4">12. Contact Us</h2>
            <p className="text-gray-600 mb-4">
              If you have any questions about this privacy policy or our data practices, please 
              contact us:
            </p>
            <div className="bg-gray-100 p-4 rounded-lg mb-6">
              <p className="text-gray-800 font-medium">MTClicks Privacy Team</p>
              <p className="text-gray-600">Email: privacy@mtclicks.com</p>
              <p className="text-gray-600">Phone: +1 (555) 123-4567</p>
              <p className="text-gray-600">Address: 123 Marketing Street, Digital City, DC 12345</p>
            </div>

            <div className="bg-green-50 border-l-4 border-green-400 p-4">
              <p className="text-green-800">
                <strong>Your Privacy Matters:</strong> We are committed to protecting your privacy 
                and being transparent about our data practices.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
